import moment from 'moment';
import * as actions from 'redux/store/actions';


class SprintCreatorPopup {
  constructor($ngRedux, $scope, durationService) {
    'ngInject';
    this.formatter = durationService.getFormatter({ mode: 'hm' });

    const mapStateToThis = state => ({
      sprint: state.configuration.sprint.fieldset.sprintValue,
      recommendedCapacity: state.configuration.sprint.fieldset.recommendedCapacity,
      startDateMin: state.configuration.sprint.fieldset.startDateMin,
      startDateMax: state.configuration.sprint.fieldset.startDateMax,
      endDateMin: state.configuration.sprint.fieldset.endDateMin,
      currentTab: state.configuration.sprint.fieldset.currentTab,
      weekOptions: state.configuration.sprint.fieldset.weekOptions,
      teamOptions: state.configuration.sprint.fieldset.teamOptions,
      selectedWeek: state.configuration.sprint.fieldset.selectedWeek,
      selectedTeam: state.configuration.sprint.fieldset.selectedTeam,
      weekDetails: state.configuration.sprint.fieldset.weekDetails,
      userWeekDays: state.configuration.sprint.fieldset.userWeekDays,
      loading: state.services.api.configuration.sprint.templateFetching ||
      state.services.api.configuration.sprint.upserting,
      costOfEstimationModel: state.configuration.sprint.fieldset.costOfEstimationModel,
    });
    const mapDispatchToThis = ({
      create: actions.configuration.sprint.creator.create.begin,
      close: actions.configuration.sprint.creator.close,
      setTab: actions.configuration.sprint.fieldset.setTab,
      setWeek: actions.configuration.sprint.fieldset.setWeek,
      setUserDay: actions.configuration.sprint.fieldset.setUserDay.begin,
      setName: actions.configuration.sprint.fieldset.setName,
      setStartDate: actions.configuration.sprint.fieldset.setStartDate,
      setEndDate: actions.configuration.sprint.fieldset.setEndDate,
      setCapacity: actions.configuration.sprint.fieldset.setCapacity,
      setHourCapacity: actions.configuration.sprint.fieldset.setHourCapacity,
      setTeam: actions.configuration.sprint.creator.setTeam,
      setCostOfEstimation: actions.configuration.sprint.fieldset.setCostOfEstimation.begin,
      inheritCostChange: actions.configuration.sprint.fieldset.setCostInherit.begin,
      setWorkingDuration: actions.configuration.sprint.fieldset.setWorkingDuration.begin,
    });
    const unsubscribe = $ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    $scope.$on('$destroy', unsubscribe);
    $('[data-toggle="tooltip"]').tooltip();
  }

  onTabChange(tab) {
    this.setTab(tab);
  }

  onSave() {
    this.create({
      projectId: this.sprint.projectId,
      prevId: this.sprint.prevId,
      teamId: this.selectedTeam.id,
      name: this.sprint.name,
      startDate: this.sprint.startDate,
      endDate: this.sprint.endDate,
      capacity: this.sprint.capacity,
      users: this.sprint.users,
      costOfEstimationUnit: +this.sprint.costOfEstimationUnit,
      costOfEstUnitInherit: this.sprint.costOfEstUnitInherit,
      status: this.sprint.status
    });
    this.close();
  }

  onSelectedWeek(week) {
    this.setWeek(week);
  }

  onUserDayChange(user, day) {
    this.setUserDay({ user, day });
  }

  onNameChanged() {
    this.setName(this.sprint.name);
  }

  onStartDateChanged() {
    this.setStartDate(moment(this.sprint.startDate).toISOString());
  }

  onEndDateChanged() {
    this.setEndDate(moment(this.sprint.endDate).toISOString());
  }

  onCapacityChanged() {
    this.setCapacity(Number(this.sprint.capacity));
  }

  onHourCapacityChanged() {
    this.setHourCapacity(Number(this.sprint.hourCapacity));
  }

  onSelectedTeam() {
    this.setTeam(this.selectedTeam.id);
  }

  onInheritChanged() {
    this.inheritCostChange({ costOfEstUnitInherit: this.sprint.costOfEstUnitInherit });
  }

  onCostChanged() {
    this.setCostOfEstimation(this.costOfEstimationModel);
  }

  onWorkingDurationChanged(user) {
    this.setWorkingDuration({ user })
  }

  isCompleted() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.completed;
  }

  isUpcoming() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.upcoming;
  }

  isActive() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.active;
  }
}

export default SprintCreatorPopup;



// WEBPACK FOOTER //
// ./components/popups/sprint/creator/sprint-creator-popup.controller.js